import { DarkMode, LightMode } from "@mui/icons-material";
import InfoIcon from '@mui/icons-material/Info';

import { Button, Grid, IconButton, Typography } from "@mui/material";
import React from "react";

function TopGridComponent({userSignedIn, handleSignOut, handleSignIn, userName, toggleTheme, isDarkMode, handleInfoOpen}) {
    return (
    <Grid container spacing={2} alignItems="center" >
      <Grid item>
        {userSignedIn ? <Button variant="outlined" color="primary" onClick={handleSignOut}>
          Sign Out
        </Button> : <Button variant="contained" color="primary" onClick={handleSignIn}>
          Sign Up
        </Button>}
      </Grid>
      <Grid item>
        <Typography variant="body1" fontFamily="Raleway">Welcome {userSignedIn ? userName : 'Guest'}</Typography>
        {!userSignedIn && <Typography fontFamily="Raleway" fontWeight='100' sx={{fontSize: 14}}>
          💡 Sign up in order to save your words
          </Typography>}
      </Grid>
      <Grid container sx={{
  justifyContent: 'flex-end'
}}>
        <IconButton aria-label="themeButton" onClick={toggleTheme}>
          {isDarkMode ? <LightMode /> : <DarkMode />}
        </IconButton>
        <IconButton aria-label="infoButton" onClick={handleInfoOpen}>
          <InfoIcon></InfoIcon>
        </IconButton>
      </Grid>
      <Grid item xs={12} sx={{
  p: 2
}}>
        <Typography variant="h3" align="center" fontFamily="Raleway" fontWeight='700'>
          VocaBuddy
        </Typography>
        <Typography variant="h5" align="center" fontFamily="Raleway" fontWeight='500'>
          Store & practice your vocabulary
        </Typography>
      </Grid>
      
    </Grid>);
  }

export default TopGridComponent;